import React from 'react'
import AIChat from '../components/AIChat'

const AIAgent = () => <AIChat variant="page" allowClear />

export default AIAgent
